import {Card} from "@material-ui/core";
import {CreateProps} from "react-admin";
import {CustomCreate} from "../../components/CustomCreate";
import {UserClientForm} from "./UserClientForm";

export const UserClientCreate = (props: CreateProps) => {
  return (
    <CustomCreate {...props} component={Card}>
      <UserClientForm />
    </CustomCreate>
  );
};
